import { render, staticRenderFns } from "./RegiaoRoute.vue?vue&type=template&id=2e5a7850"
import script from "./RegiaoRoute.vue?vue&type=script&lang=js"
export * from "./RegiaoRoute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports